"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useWebSpeechPonyfill;

var _useWebChatUIContext = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useWebSpeechPonyfill() {
  return [(0, _useWebChatUIContext.default)().webSpeechPonyfill];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VXZWJTcGVlY2hQb255ZmlsbC50cyJdLCJuYW1lcyI6WyJ1c2VXZWJTcGVlY2hQb255ZmlsbCIsIndlYlNwZWVjaFBvbnlmaWxsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRUE7Ozs7QUFFZSxTQUFTQSxvQkFBVCxHQUFxRDtBQUNsRSxTQUFPLENBQUMsb0NBQXNCQyxpQkFBdkIsQ0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBXZWJTcGVlY2hQb255ZmlsbCB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5cbmltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVdlYlNwZWVjaFBvbnlmaWxsKCk6IFtXZWJTcGVlY2hQb255ZmlsbF0ge1xuICByZXR1cm4gW3VzZVdlYkNoYXRVSUNvbnRleHQoKS53ZWJTcGVlY2hQb255ZmlsbF07XG59XG4iXX0=